// MR-MOB — **WHERE THE PORTALLED MEMBER MENU GOES.** (her order, 2026-08-10)
//
// It is a `.js` law rather than a function inside `AccountMenuPortal.tsx` for this house's standing
// reason: **a law inside a TSX file cannot be imported by a `.mjs` gate**, and node refuses a `.tsx`
// extension outright. The panel's POSITION is the half of this round most likely to rot silently —
// a menu a few pixels off is invisible in review and obvious on a phone — so it is the half that
// has to be runnable.
//
// It imports NOTHING, which is the entry requirement.

// Where the panel's top-right corner goes, in VIEWPORT coordinates, from the pill's own rect.
// `right` is measured from the viewport's right edge because that is the edge the panel aligns to —
// the same alignment the absolute rule had (`right: 0` inside `.account-menu`).
//
// **AN ABSENT OR MALFORMED ANCHOR IS A REAL STATE AND IT ANSWERS THE HEADER'S OWN CORNER** rather
// than 0,0 or NaN: a menu that opened in the top-left of the screen because a ref had not attached
// yet would be a worse failure than one a few pixels off, and `top: NaNpx` is not a position at all
// (R18 — two facts, and the fallback is the honest one).
export const ACCOUNT_MENU_FALLBACK = { top: 64, right: 12 };

export function anchorBox(rect, viewportWidth, gap = 8) {
  if (!rect || !Number.isFinite(rect.bottom) || !Number.isFinite(rect.right)) return { ...ACCOUNT_MENU_FALLBACK };
  const width = Number.isFinite(viewportWidth) ? viewportWidth : 0;
  return {
    top: Math.round(rect.bottom + gap),
    // Never negative: a pill flush with the right edge must not push the panel off screen.
    right: Math.max(0, Math.round(width - rect.right)),
  };
}
